import { render } from "./SpinnerIcons.vue?vue&type=template&id=d516cd1a&scoped=true"
import script from "./SpinnerIcons.vue?vue&type=script&lang=js"
export * from "./SpinnerIcons.vue?vue&type=script&lang=js"

import "./SpinnerIcons.vue?vue&type=style&index=0&id=d516cd1a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d516cd1a"]])

export default __exports__